'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationButton = function PaginationButton(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === undefined ? false : _ref$active,
      children = _ref.children,
      className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$href = _ref.href,
      href = _ref$href === undefined ? '#' : _ref$href,
      onSelect = _ref.onSelect;

  var classes = {
    'waves-effect': true,
    disabled: disabled,
    active: active
  };

  return _react2.default.createElement(
    'li',
    { className: (0, _classnames2.default)(classes, className), onClick: onSelect },
    _react2.default.createElement(
      'a',
      { href: href },
      children
    )
  );
};

PaginationButton.propTypes = {
  active: _react.PropTypes.bool,
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  disabled: _react.PropTypes.bool,
  href: _react.PropTypes.string,
  onSelect: _react.PropTypes.func
};

exports.default = PaginationButton;


//////////////////
// WEBPACK FOOTER
// ./~/react-materialize/lib/PaginationButton.js
// module id = 106
// module chunks = 0